import React, { MouseEventHandler } from 'react';
import styles from './TextButton.module.css';

interface Props {
  text: string;
  left?: React.ReactNode;
  right?: React.ReactNode;
  disabled?: boolean;
  underline?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  className?: string;
}

function TextButton({ text, left, right, disabled = false, underline = false, onClick, className }: Props) {
  return (
    <button
      type="button"
      className={`${styles.textButton} ${underline ? styles.underline : ''} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {left && left}
      {text}
      {right && right}
    </button>
  );
}

export default TextButton;
